import _ from 'lodash';
import { Redirect, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import EditFormSeparatorField from 'modules/ui/editform/fields/EditFormSeparatorField';
import EmailChangeRequestField from '../component/EmailChangeRequestField';
import PasswordResetRequestField from '../component/PasswordResetRequestField';
import UserProfileEditService from '../service/UserProfileEditService';

const blockClassName = 'rounded-8 border px-16 pt-10 pb-4 mb-16';
const blockTitleClassName = 'py-8';

const config = {
	key: 'userProfileEditForm',
	text: 'Profile',
	service: UserProfileEditService,
	icon: 'person',
	hideBackLink: true,
	noNavigationAfterSave: true,
	fields: [
		{
			key: 'name',
			text: 'Name',
			component: EditFormTextField,
			readOnly: true,
			required: true
		},
		{
			key: 'emailGroup',
			component: EditFormGroupFields,
			className: blockClassName,
			fields: [
				{
					key: 'sepEmail',
					text: 'E-mail Address Change',
					component: EditFormSeparatorField,
					className: blockTitleClassName,
					isControlledInput: false
				},
				{
					key: 'oldEmail',
					text: 'Current E-mail Address',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'email',
					text: 'New E-mail Address',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'emailAgain',
					text: 'New E-mail Address Again',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'emailDialog',
					component: EmailChangeRequestField,
				}
			]
		},
		{
			key: 'passwordGroup',
			component: EditFormGroupFields,
			className: blockClassName,
			fields: [
				{
					key: 'sepPassword',
					text: 'Password Change',
					component: EditFormSeparatorField,
					className: blockTitleClassName,
					isControlledInput: false
				},
				{
					key: 'passwordEmail',
					text: 'E-mail Address',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'passwordDialog',
					component: PasswordResetRequestField
				}
			]
		}
	]
};

function UserProfileEditForm() {
	const user = useSelector(({ auth }) => auth.user);
	const { id } = useParams();
	if (_.isUndefined(id)) {
		return <Redirect to={`/profile/${user.data.id}`} />;
	}

	return <EditFormPage config={config} />;
}

export default UserProfileEditForm;
